import {useState, useEffect} from "react"

import ShelfApi from "~/utils/ShelfApi"

export const useApi = (url, params = {}, options = {timestamp: null}) => {
  const [data, setData] = useState(useApi.LOADING)

  useEffect(() => {
    setData(useApi.LOADING)
    ShelfApi.get(url, params)
      .then(response => {
        setData(response.data)
      })
      .catch(err => {
        console.log("Error loading data with useApi: " + err)
        setData(useApi.ERROR)
      })
  }, [url, JSON.stringify(params), options.timestamp])

  return data
}

useApi.LOADING = 0
useApi.ERROR = -1



// WEBPACK FOOTER //
// ./src/hooks/useApi.js